export default "__VITE_ASSET__806c2fd0__"